import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Link, Typography, FormGroup, FormControlLabel, Checkbox } from '@material-ui/core';
import { getItem, setItem } from 'storage';
import { IS_REMEMBER, REMEMBER_EMAIL, REMEMBER_ROLE, userRoles } from 'utility/lookup';
import CustomTextField from 'components/Input/CustomTextField';
import NewsContactPopup from './newsContactPopup';
import CustomButton from 'components/CustomInput/Button/index';
import CustomOutlineSelect from 'components/Input/CustomOutlineSelect';
import PasswordTextField from 'components/Input/PasswordTextField';
import { LOGIN_USER } from 'store/key';
import { useHistory } from 'react-router';

// 1. -	For the first time login, it forces user to change the password
// 2. -	If the email account is not registered in system, an alert message will be prompted to inform user to register the email account before login.
//  3. -	Provide links for “Sign Up”, “Forgot Password” & “Resend Account Activation”

const LoginLayout = (props) => {
    const {
        setPageComponent,
        showSignUpLayout,
        showForgotPasswordLayout,
        showResendActivationLayout,
    } = props;
    const dispatch = useDispatch();
    const isLoading = useSelector((state) => state.user.isLoading);

    // const isError = useSelector((state) => state.user.isError);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const [role, setRole] = useState(userRoles[0]?.key || '');
    const [rememberChecked, setRememberChecked] = useState(false);

    const [popupType, setPopupType] = useState('');
    const [openPopup, setOpenPopup] = useState(false);

    const [isEmailValid, setEmailValid] = useState(false);
    const [isPwdValid, setPwdValid] = useState(false);
    const [forceShowError, setForceShowError] = useState(false);
    const history = useHistory();

    //get localStorage and set state value at beginning
    useEffect(() => {
        const role = getItem(REMEMBER_ROLE);
        const email = getItem(REMEMBER_EMAIL);
        const isRememberChecked = getItem(IS_REMEMBER);
        //role !== null, undefined, ""
        if (role && email && isRememberChecked === true) {
            setRole(role);
            setEmail(email);
            setRememberChecked(isRememberChecked);
        }
    }, []);

    const handleRoleChange = (e) => {
        setRole(e.target.value);
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleRememberCheckedChange = (e) => {
        setRememberChecked(e.target.checked);

        setItem(IS_REMEMBER, e.target.checked);

        if (!e.target.checked) {
            setItem(REMEMBER_ROLE, '');
            setItem(REMEMBER_EMAIL, '');
        }
    };

    const handleSignUpClick = (e) => {
        setPageComponent(showSignUpLayout);
    };

    const handleForgotPasswordClick = (e) => {
        setPageComponent(showForgotPasswordLayout);
    };

    const handleAccountActivationClick = (e) => {
        setPageComponent(showResendActivationLayout);
    };

    //Login clicked
    const onSubmit = async (e) => {
        setForceShowError(true);

        if (isEmailValid && isPwdValid && email && password) {
            const requestData = {
                username: email,
                password: password,
                role: role,
                rememberChecked,
                callback: () => {
                    history.push('/');
                },
            };

            dispatch({
                type: LOGIN_USER,
                payload: requestData,
                callback: () => {
                    const isRemember = getItem(IS_REMEMBER);

                    if (isRemember) {
                        setItem(REMEMBER_EMAIL, email);
                        setItem(REMEMBER_ROLE, role);
                    }
                },
            });
        }
    };

    return (
        <div>
            {openPopup && <NewsContactPopup popupType={popupType} setOpenPopup={setOpenPopup} />}
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <div style={{ fontSize: 18, fontWeight: 'bold' }}>Login</div>
                </Grid>

                <Grid item xs={12}>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            width: '100%',
                        }}
                    >
                        <Grid style={{ display: 'flex' }}>
                            <div style={{ marginRight: 5 }}>Don't have an account? </div>
                            <Link href="#" onClick={handleSignUpClick}>
                                Sign Up
                            </Link>
                        </Grid>
                        <Grid>
                            <Link href="#" onClick={handleAccountActivationClick}>
                                Resend Account Activation
                            </Link>
                        </Grid>
                    </div>
                </Grid>

                {/* Email */}
                <Grid item xs={12}>
                    <CustomTextField
                        isValidValue={(isValid) => {
                            setEmailValid(isValid);
                        }}
                        validators={['isRequired', 'isEmail', 'disableChinese']}
                        forceErrorDisplay={forceShowError}
                        label="Email"
                        value={email}
                        disabled={isLoading}
                        onChange={handleEmailChange}
                        isNoSpace
                        maxLength={255}
                        showErrorWhenOnBlur
                    />
                </Grid>

                {/* Password */}
                <Grid item xs={12}>
                    <PasswordTextField
                        label="Password"
                        value={password}
                        disabled={isLoading}
                        onPressEnter={onSubmit}
                        handleChange={handlePasswordChange}
                        isValidValue={(isValid) => {
                            setPwdValid(isValid);
                        }}
                        validators={['isRequired', 'disableChinese']}
                        forceErrorDisplay={forceShowError}
                        maxLength={255}
                    />
                </Grid>

                <Grid item xs={12}>
                    <CustomOutlineSelect
                        value={role}
                        label="Role"
                        choices={userRoles
                            .filter((item) => !item.isHidden)
                            .map((item) => {
                                return {
                                    key: item.key,
                                    display: item.display,
                                };
                            })}
                        onChange={handleRoleChange}
                    />
                </Grid>

                {/* Remember User Name */}
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        paddingLeft: 8,
                        paddingRight: 8,
                        width: '100%',
                    }}
                >
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={rememberChecked}
                                    onChange={handleRememberCheckedChange}
                                    color="primary"
                                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                                    size={'small'}
                                />
                            }
                            label="Remember User And Role"
                        />
                    </FormGroup>

                    <Typography>
                        <Link href="#" onClick={handleForgotPasswordClick}>
                            Forgot Password
                        </Link>
                    </Typography>
                </div>

                <Grid item xs={12}>
                    <CustomButton loading={isLoading} id="login-page-form-submit" fullWidth onClick={onSubmit}>
                        Login
                    </CustomButton>
                </Grid>
                <Grid container justify="space-around" alignItems="center">
                    <Grid>
                        <CustomButton
                            id="login-page-news-button"
                            onClick={() => {
                                setPopupType('news');
                                setOpenPopup(true);
                            }}
                        >
                            {/* <FiberNew color="primary" style={{fontSize: 36}} /> */}
                            NEWS
                        </CustomButton>
                    </Grid>
                    <Grid>
                        <CustomButton
                            id="login-page-contact-button"
                            onClick={() => {
                                setPopupType('contact');
                                setOpenPopup(true);
                            }}
                        >
                            CONTACTS
                        </CustomButton>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
};

export default LoginLayout;
